import React from 'react';
import { BookOpen, Key, FolderHeart } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-16 md:py-24 px-4 bg-burgundy text-cream relative overflow-hidden" data-id="element-61">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-2 bg-gold" data-id="element-62"></div>
      <div className="absolute bottom-0 left-0 w-full h-2 bg-gold" data-id="element-63"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-64">
        <h2 className="text-3xl md:text-5xl font-bold text-gold mb-8" data-id="element-65">
          Presentamos el Método del Ancla Analógica
        </h2>

        <p className="text-xl md:text-2xl mb-10 leading-relaxed" data-id="element-66">
          Es un sistema diseñado para quienes prefieren{' '}
          <strong className="text-white font-semibold border-b border-gold/50 pb-1" data-id="element-67">
            la seguridad de lo físico
          </strong>
          . No le pediremos que instale aplicaciones complejas ni que sea una
          experta en tecnología.
        </p>

        <div className="bg-white/10 p-8 md:p-12 rounded-sm backdrop-blur-sm border border-gold/30" data-id="element-68">
          <p className="text-xl leading-relaxed mb-8" data-id="element-69">
            Este método utiliza una estrategia de "Puente" entre su casa y el
            mundo digital, asegurando que sus herederos tengan las{' '}
            <span className="text-gold font-bold italic" data-id="element-70">
              "Llaves Maestras"
            </span>{' '}
            necesarias en una carpeta física y segura que nunca falla.
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-8 mt-10" data-id="element-71">
            <div className="flex flex-col items-center" data-id="element-72">
              <div className="w-16 h-16 rounded-full bg-gold flex items-center justify-center mb-4" data-id="element-73">
                <BookOpen className="w-8 h-8 text-burgundy" data-id="element-74" />
              </div>
              <span className="font-heading text-lg text-gold" data-id="element-75">Físico</span>
            </div>
            <div className="hidden md:block w-16 h-0.5 bg-gold/50" data-id="element-76"></div>
            <div className="flex flex-col items-center" data-id="element-77">
              <div className="w-16 h-16 rounded-full bg-gold flex items-center justify-center mb-4" data-id="element-78">
                <Key className="w-8 h-8 text-burgundy" data-id="element-79" />
              </div>
              <span className="font-heading text-lg text-gold" data-id="element-80">Seguro</span>
            </div>
            <div className="hidden md:block w-16 h-0.5 bg-gold/50" data-id="element-81"></div>
            <div className="flex flex-col items-center" data-id="element-82">
              <div className="w-16 h-16 rounded-full bg-gold flex items-center justify-center mb-4" data-id="element-83">
                <FolderHeart className="w-8 h-8 text-burgundy" data-id="element-84" />
              </div>
              <span className="font-heading text-lg text-gold" data-id="element-85">Familiar</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}